import React, {useState, useEffect} from 'react'
//! Styles
import './appm-5.style.css'
//! SweetAlert
import Swal from 'sweetalert2'
import { Base_API } from '../../_actions/matcher';


function Appointment_5() {

    const [dataForm, setDataForm] = useState([
        {
            id: 1,
            title: 'ท่านได้รับรู้โปรโมชั่นนี้จากช่องทางไหน?',
            dd_list: [
                'Select your answer',
                'Line',
                'Facebook'
            ],
            value: ''
        }
    ]);
    const [contactUsMsg, setContactUsMsg] = useState('ติดต่อสอบถามเพิ่มเติมได้ที่ xx-xxx-xxxx หรือ info@nilecon.com ....');
    const [errorMsg, setErrorMsg] = useState('');
    const [errorStatus, setErrorStatus] = useState(false);
    const [statementPreview, setStatementPreview] = useState('');

    // check & clear
    // useEffect(() => {
    //     // check
    //     if(window.localStorage.getItem('formData_page-3') === null)
    //     {
    //         window.location.href = '/lineoa/n-health/form/3'
    //     }
    // })
    // useEffect(() => {
    //     // clear
    //     if(window.localStorage.getItem('formData_page-4') !== null)
    //     {
    //         window.localStorage.removeItem('formData_page-4');
    //         window.location.reload();
    //     }

    // },[])

    const showAlert = (msg) => {
        Swal.fire({
            title: "ผิดพลาด",
            text: msg,
            icon: 'error',
            confirmButtonText: 'ตกลง',
            customClass: {
                actions: 'my-actions',
                cancelButton: 'order-1 right-gap',
                confirmButton: 'order-2',
                denyButton: 'order-3',
            }        
        })
    }
    const onBack = () => {
        window.location.href = `${Base_API.pathWeb}/n-health/packages`;
    }
    const onSubmit = () => {
        window.location.href = `${Base_API.pathWeb}/n-health/form/5`
    }
    const onUploadFile = (file) => {
        let fileType = String(file.type).split("/")[1];
        let urlPreview = URL.createObjectURL(file);
        //console.log(urlPreview) 
        if(fileType === 'jpg' || fileType === 'jpeg' || fileType === 'png')
        {
            setStatementPreview(urlPreview);
        }else
        {
            showAlert('กรุณาอัปโหลดไฟล์ png, jpg, jpeg.');
        }
    }
    const onChangeDD = (e, id) => {
        // changed
        dataForm.map(item => {
            if(item.id === id)
            {
                item.value = e.target.value;
            }
        })

        if(e.target.value !== 'Select your answer')
        {
            // style
            document.querySelector(`.appm-5-dropdown_${id}`).style.color = '#202020'
        }else
        {
            // style
            document.querySelector(`.appm-5-dropdown_${id}`).style.color = '#D2D9E3'
        }
    }

    return (
        <div className="appm-5_container">
            <div className="appm-5-form_wrapper">
                {/* header */}
                <h1 className="appm-5-form_header">ทำรายการสั่งซื้อสำเร็จ</h1>
                {/* title */}
                <p className="appm-5-form_title">หมายเลขคำสั่งซื้อของคุณ <span>0001</span> ขอบคุณที่ใช้บริการ N Health </p>

                {/* icon */}
                <div className="appm-5-icon">
                    <img src={require('../../assets/images/icons/success.png')} />
                </div>

                <div className="appm-5-assessment-wrapper">
                    {/* assessment */}
                    {dataForm.map((list, i) => 
                        <>
                            <p className="appm-5-assessment-title">{list.title}</p>
                            <select
                                className={`dropdown-select appm-5-dropdown_${list.id}`}  
                                onChange={e => onChangeDD(e, list.id)}
                            >
                                {list.dd_list.map((item, i) => 
                                    <option value={item} key={i}>{item}</option> 
                                )}
                            </select>
                        </>
                    )}
                </div>

                {/* button */}
                <div className="appm-5-btn">
                    <button 
                        onClick={onBack}
                    >
                        ปิดหน้านี้
                    </button>
                    {/* contact us */}
                    {/* contact us */}
                    <div className="appm-5-contact_us">
                        <h3>สอบถามรายละเอียดและนัดหมายเพื่อรับบริการได้ที่</h3>
                        <span>N Health Customer service 02-7624000 กด1 หรือ กด9</span>
                        <span>Line: @nhealth</span>
                    </div>
                </div>


            </div>
            {/* footer */}
            <p className="footer-text">Copyright © 2022 National Healthcare Systems Company Limited All rights reserved</p> 
        </div>
    )
}

export default Appointment_5